
import { FC } from 'react'


type Props = {
  userObj: any
}

const NumberCell: FC<Props> = ({ userObj }) => {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>
        <span className='text-gray-800 mb-1' style={{ textTransform: "capitalize" }}>
          {userObj ? userObj : "0"}
        </span>
      </div>
    </div>
  )
}

export { NumberCell }
